import { Badge, tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import { GraphQL } from "@rpi/openapi-api";
import React from "react";
import { KeyStatusBadgeColor, apiKeyStatusBadgeConfig } from "./apiKeyStatus";

const useStyles = createStyles(() => ({
  badgeWrapper: {
    display: "inline-flex",
  },
  dot: {
    fontVariationSettings: "'FILL' 1",
  },
}));

/** Dot colors matching the Badge component's text shade per color, as in OrderStatusCellV2. */
const dotColorByBadgeColor: Record<KeyStatusBadgeColor, string> = {
  green: tokens.color.primitive.light.green[700],
  gray: tokens.color.primitive.light.gray[700],
};

interface KeyStatusBadgeProps {
  status: GraphQL.ApiKeyStatus;
}

export const KeyStatusBadge: React.FC<KeyStatusBadgeProps> = ({ status }) => {
  const { classes } = useStyles();
  const config = apiKeyStatusBadgeConfig[status];
  return (
    <span data-testid="key-status-badge" className={classes.badgeWrapper}>
      <Badge
        label={config.label}
        color={config.color}
        variant="round"
        size="small"
        border
        icon={<IconV3 icon="circle" size={12} color={dotColorByBadgeColor[config.color]} className={classes.dot} />}
      />
    </span>
  );
};
